import { Exercise } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

import { UseGetAllPageSizeProps } from '../types';
import usePermittedQuery from '../usePermittedQuery';

export const GET_COMBINED_EXERCISES_KEY = 'get-combined-exercises';

export const useGetCombinedExercises = ({
  page = 0,
  size = 1000,
}: UseGetAllPageSizeProps) => {
  return usePermittedQuery<Exercise[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/exercise/combined-exercises?page=${page}&size=${size}`,
    {},
    [GET_COMBINED_EXERCISES_KEY],
    {
      enabled: typeof page === 'number' && page >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
